import Dialog from "@/components/Dialog/Dialog";
import { Slot } from "utils/create-slots";
import { UI_LAYER } from "../Usercentrics";
import { Button } from "@/components/Button/Button";

const FirstLayer = ({
  labels,
  onTCFUICloseHandler,
  onUpdateViewHandler,
  onAcceptAllHandler,
}) => (
  <Dialog
    open={true}
    onOpenChange={onTCFUICloseHandler}
    position="bottom"
    width="fullwidth"
    showDefaultDialogClose={false}
    onInteractOutside={(e) => e.preventDefault()}
    onPointerDownOutside={(e) => e.preventDefault()}
    onEscapeKeyDown={(e) => e.preventDefault()}
  >
    <Slot name="title">
      <p className="lg:text-4xl text-2xl lg:p-8 px-6">
        {labels?.firstLayer?.title}
      </p>
    </Slot>
    <Slot name="content">
      {labels?.firstLayer?.description?.short && (
        <div
          className="text-small my-4 text-gray-600 lg:px-8 px-6"
          dangerouslySetInnerHTML={{
            __html: labels?.firstLayer?.description?.short,
          }}
        />
      )}
      <div className="flex justify-between mt-6 lg:px-8 px-6">
        <Button
          className=""
          variant="link"
          onClick={() => onUpdateViewHandler(UI_LAYER.SECOND_LAYER)}
        >
          {labels.buttons.showSecondLayer}
        </Button>

        <Button
          className="lg:mr-5 mr-1 lg:w-1/3 w-2/3"
          onClick={() => onAcceptAllHandler()}
          size="small"
        >
          {labels.buttons.acceptAll}
        </Button>
      </div>
    </Slot>
  </Dialog>
);

export default FirstLayer;
